export default {
  "supplierCollab": {
    "intro": "공급업체 기본 정보는 SAP에서 수신하며 담당자와 이메일은 여기에서 통합 관리합니다.",
    "contacts": "담당자·이메일",
    "code": "공급업체 코드",
    "name": "SAP 공급업체명",
    "country": "국가",
    "language": "언어",
    "group": "SAP 계정 그룹",
    "source": "자료 출처",
    "legacy": "기존 가져오기",
    "readonly": "기본 정보는 SAP에서 동기화하며 코드·이름은 읽기 전용입니다.",
    "legacyHint": "SAP 연결이 완료되지 않았습니다. 원본을 확인한 후 담당자를 추가하세요.",
    "search": "공급업체 코드·이름·기존 별칭 검색",
    "kind": "업무 용도",
    "fabric": "원단",
    "trim": "부자재",
    "addContact": "담당자 추가",
    "editContact": "담당자 수정",
    "emails": "알림 이메일",
    "primaryEmail": "기본 이메일",
    "emailLabel": "이메일 메모",
    "account": "플랫폼 계정",
    "notificationOnly": "알림 전용",
    "enableAccount": "공급업체 플랫폼 계정 활성화",
    "accountHint": "계정은 사람별로 발급합니다. 이메일을 추가해도 자료 접근 권한은 늘어나지 않습니다.",
    "addEmail": "이메일 추가",
    "emailInvalid": "유효하고 중복되지 않는 이메일을 입력하고 기본 주소 하나를 선택하세요.",
    "disable": "비활성화",
    "disableConfirm": "담당자를 비활성화하고 로그인 세션을 해제할까요? 이전 발행·회신 기록은 유지합니다.",
    "enableConfirm": "담당자를 다시 활성화할까요?",
    "bind": "기존 담당자 연결",
    "bindHint": "신원이 확인된 기존 담당자를 선택하세요. 업체명으로 자동 연결하지 않습니다.",
    "bindConfirm": "{name} 계정을 {code} · {supplier}에 연결할까요? 감사 이력이 기록됩니다.",
    "syncStatus": "SAP {system} · 원본 {n}개 · 동기화 대기 {pending}개",
    "autoOn": "자동 동기화 사용",
    "autoOff": "자동 동기화 중지",
    "syncPreview": "공급업체 동기화 미리보기",
    "syncSummary": "원본 {n}개, 대기 {pending}개, 오류 {errors}개입니다.",
    "syncBlocked": "원본 오류를 먼저 확인하세요. 미리보기에서는 공급업체 정보를 저장하지 않습니다.",
    "syncChange": "변경",
    "syncCreate": "추가",
    "syncUpdate": "수정",
    "syncApply": "이번 동기화 적용",
    "syncConfirm": "미리보기의 이번 공급업체 동기화(최대 {n}개)를 적용할까요? 담당자·이메일·계정·이전 자료는 유지합니다.",
    "syncApplied": "이번에 {n}개 처리했으며 {remaining}개가 남았습니다.",
    "all": "전체",
    "actions": "작업",
    "saved": "저장했습니다",
    "identityRequired": "SAP 공급업체 연결이 없습니다. 생산 정보에서 코드를 선택한 후 다시 미리보기하세요.",
    "copyContacts": "참조 담당자",
    "primaryContact": "주 담당자(확인 담당)",
    "copyHint": "포털 참조 담당자는 이번 자료를 조회합니다. 알림 전용 담당자는 메일만 받고 주 담당자가 확인을 제출합니다.",
    "notifyEmails": "이번 알림 수신 주소",
    "noEmail": "사용 가능한 이메일이 없습니다. 공급업체 정보에 추가하거나 플랫폼에만 발행하세요.",
    "noAddress": "수신 이메일을 하나 이상 선택하세요.",
    "manageContacts": "공급업체 담당자 관리",
    "supplierReadonly": "공급업체는 의뢰서 생산 정보에서 가져옵니다. 변경하려면 의뢰서로 돌아가세요.",
    "deliveryStatus": "주소별 발송 현황",
    "changePrimary": "주 담당자 인계",
    "changePrimaryConfirm": "이번 자료의 주 담당자를 {name}에게 인계할까요? 이전 회신은 유지하며 변경 이력을 기록합니다.",
    "primaryChanged": "주 담당자를 변경했습니다",
    "recipientRole": "수신 역할",
    "primaryRole": "주 담당",
    "copyRole": "참조",
    "retryDelivery": "이 주소 재시도",
    "retryDeliveryConfirm": "{email}의 실패 메일만 재전송할까요? 다른 주소에는 중복 발송하지 않습니다.",
    "accountsMoved": "공급업체 담당자·계정은 공급업체 관리로 통합했습니다.",
    "retryDone": "실패 주소의 재시도를 요청했습니다",
    "emailOnly": "메일 알림만",
    "platformPrimaryRequired": "주 담당자의 공급업체 포털 계정을 먼저 개설해 주세요.",
    "productionSetup": "생산 정보 입력",
    "productionSetupHint": "공급업체 코드 또는 이름으로 업체를 선택하고 입고 요청일을 입력해 주세요. 한 번에 동일 공급업체의 최대 20개 스타일을 전송하며, 저장 후 작업지시서를 미리 봅니다.",
    "splitSupplierBatch": "선택한 스타일의 공급업체가 다릅니다. 업체별로 나누어 전송해 주세요. 생산 공급업체를 실제로 변경할 때만 연결을 수정해 주세요.",
    "saveAndPreview": "저장 후 미리보기",
    "productionSaveReview": "일부 생산 정보가 저장되었을 수 있습니다. 새로고침하여 확인한 후 계속해 주세요. 공급업체에는 아직 게시되지 않았습니다.",
    "quickContactHint": "현재 공급업체 정보에 담당자를 저장하고 이번 스타일의 브랜드용 개별 포털 계정을 개설합니다. 이메일은 선택 사항입니다. 전송을 취소해도 저장한 담당자는 유지됩니다.",
    "saveAndSelectContact": "저장 후 선택",
    "contactSavedForReuse": "공급업체 정보에 담당자를 저장하고 이번 전송의 주 담당자로 선택했습니다.",
    "contactCreateUnconfirmed": "담당자 생성 결과를 확인하지 못했습니다. 담당자 목록을 새로고침하여 생성 여부를 확인하고, 이미 있으면 직접 선택해 중복 생성을 피하세요. 비밀번호를 받지 못한 경우 공급업체 정보에서 재설정할 수 있습니다.",
    "credentialsHint": "계정과 초기 비밀번호를 해당 담당자에게 안전하게 전달해 주세요. 비밀번호는 이번에만 표시되며 닫은 후에는 공급업체 정보에서 재설정할 수 있습니다. 이메일이나 작업지시서에는 저장하지 않습니다.",
    "sapDetails": "공급업체 SAP 상세",
    "moreActions": "추가 작업",
    "accountActive": "활성",
    "enableContact": "담당자 활성화",
    "noContacts": "등록된 담당자가 없습니다",
    "deleteContact": "담당자 삭제",
    "deleteContactConfirm": "담당자 ‘{name}’의 이메일과 포털 계정을 함께 삭제할까요? 삭제 후에는 복구할 수 없습니다.",
    "contactInUse": "이미 발행 자료 또는 메일 이력이 있는 담당자는 삭제할 수 없습니다. 이력을 보존하려면 비활성화해 주세요.",
    "contactDeleted": "담당자를 삭제했습니다",
    "deleteUnconfirmed": "삭제 결과를 확인하지 못했습니다. 담당자 목록을 새로고침하여 확인한 후 계속해 주세요.",
    "refreshBeforeDelete": "담당자 목록을 새로고침한 후 삭제해 주세요."
  }
};
